import { IsoTime } from '@coa/types';
import dayjs from 'dayjs';

export function getIsInThePast(isoTimeStr: IsoTime) {
  const now = dayjs();
  return dayjs(isoTimeStr).isBefore(now);
}
